import React, { useEffect } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { MessageSquare, Globe, Send, History, Megaphone, File } from 'lucide-react';
import { BsBoxArrowRight } from 'react-icons/bs';
import api from '../utils/api';
import { FaCog } from 'react-icons/fa';

const MainLayout = () => {

  const location = useLocation();
  const isChatActive = location.pathname === '/' || location.pathname.startsWith('/chat');

  const checkWaStatus = async () => {
    try {
      const res = await api.get('/whatsapp/checkStatus');
      if (res.status === 200) {
        localStorage.setItem('loggedIn', res?.data?.loggedIn);
      }
    } catch (err) {
      localStorage.setItem('loggedIn', false);
      console.error("Status Check Error:", err);
    }
  };
  
  useEffect(()=>{
    checkWaStatus();
  },[location.pathname]);
  

  const signout = ()=>{
    localStorage.removeItem('token'); 
    window.location.href = '/login';
  }
  return (
    <div style={{ display: 'flex', height: '100vh', width: '100vw' }}>
      <div style={{ width: '280px', borderRight: '1px solid #ddd', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' }}>
        <div className="header">
            <img src="/logo.png" alt="Profile" style={{width:'120px',height:'50px'}} />
            <div className="icons-group">
                <BsBoxArrowRight onClick={signout} title="Logout" />
            </div>
        </div>
        
        <nav style={{ flex: 1, padding: '10px' }}>
          <NavLink 
            to="/" 
            style={{
                display: 'flex', 
                alignItems: 'center', 
                padding: '12px', 
                marginBottom: '8px',
                textDecoration: 'none', 
                borderRadius: '8px',
                backgroundColor: isChatActive ? '#007bff' : 'transparent',
                color: isChatActive ? 'white' : '#333'
            }}
            >
            <MessageSquare size={20} style={{ marginRight: '10px' }} />
            Chats
          </NavLink>

          <NavLink 
            to="/web-login" 
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', padding: '12px',
              textDecoration: 'none', borderRadius: '8px',
              backgroundColor: isActive ? '#007bff' : 'transparent',
              color: isActive ? 'white' : '#333'
            })}
          >
            <Globe size={20} style={{ marginRight: '10px' }} />
            Web Login
          </NavLink>
          <NavLink 
            to="/broadcast" 
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', padding: '12px',
              textDecoration: 'none', borderRadius: '8px',
              backgroundColor: isActive ? '#007bff' : 'transparent',
              color: isActive ? 'white' : '#333'
            })}
          >
            <Send size={20} style={{ marginRight: '10px' }} />
            Broadcast
          </NavLink>
          
          <NavLink 
            to="/message-template" 
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', padding: '12px',
              textDecoration: 'none', borderRadius: '8px',
              backgroundColor: isActive ? '#007bff' : 'transparent',
              color: isActive ? 'white' : '#333'
            })}
          >
            <File size={20} style={{ marginRight: '10px' }} />
            Message Template
          </NavLink>

          <NavLink 
            to="/message-history" 
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', padding: '12px',
              textDecoration: 'none', borderRadius: '8px',
              backgroundColor: isActive ? '#007bff' : 'transparent',
              color: isActive ? 'white' : '#333'
            })}
          >
            <History size={20} style={{ marginRight: '10px' }} />
            Message History
          </NavLink>
          <NavLink 
            to="/campaign-list" 
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', padding: '12px',
              textDecoration: 'none', borderRadius: '8px',
              backgroundColor: isActive ? '#007bff' : 'transparent',
              color: isActive ? 'white' : '#333'
            })}
          >
            <Megaphone size={20} style={{ marginRight: '10px' }} />
            Campaign List
          </NavLink>

          <NavLink 
            to="/whatsapp-template" 
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', padding: '12px',
              textDecoration: 'none', borderRadius: '8px',
              backgroundColor: isActive ? '#007bff' : 'transparent',
              color: isActive ? 'white' : '#333'
            })}
          >
            <File size={20} style={{ marginRight: '10px' }} />
            Whatsapp Templates
          </NavLink>
          <NavLink 
            to="/settings" 
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', padding: '12px',
              textDecoration: 'none', borderRadius: '8px',
              backgroundColor: isActive ? '#007bff' : 'transparent',
              color: isActive ? 'white' : '#333'
            })}
          >
            <FaCog size={20} style={{ marginRight: '10px' }} />
            Settings
          </NavLink>
        </nav>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', position: 'relative' }}>
        <Outlet /> 
      </div>
    </div>
  );
};

export default MainLayout;